import { Checkbox } from '@/fsd/shared/ui/checkbox/checkbox';
import LineSVG from '@/fsd/shared/ui/icons/Line';
import { observer } from 'mobx-react-lite';
import React, { RefObject, useEffect, useRef } from 'react';
import RemainsStore from '../../model/store/RemainsStore';
import styles from '../Remains/Remains.module.scss';

interface IProps {
  showSettingsButtonRef: RefObject<HTMLButtonElement>;
}

const RemainsTableSettings = observer(({ showSettingsButtonRef }: IProps) => {
  const {
    columns,
    handleToggleAllColumns,
    handleToggleColumn,
    showSettings,
    setShowSettings,
  } = RemainsStore;

  const tableSettingsRef = useRef<HTMLDivElement>(null);

  const allColumnsSelected = columns.every((column) => column.isVisible);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tableSettingsRef.current &&
        !tableSettingsRef.current.contains(event.target as Node) &&
        showSettingsButtonRef.current &&
        !showSettingsButtonRef.current.contains(event.target as Node)
      ) {
        setShowSettings(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowSettings, showSettingsButtonRef]);

  return (
    showSettings && (
      <div ref={tableSettingsRef} className={styles.tableSettings}>
        <div className={styles.header}>Настройка таблицы</div>

        <div className={styles.column}>
          <div className={styles.head}>
            <span className={styles.label}>Столбцы</span>
            <LineSVG />
            <label htmlFor="select-all-columns" className={styles.checkAll}>
              Выбрать все
              <Checkbox
                id="select-all-columns"
                checked={allColumnsSelected}
                onChange={() => handleToggleAllColumns(!allColumnsSelected)}
              />
            </label>
          </div>

          {columns.map(
            (column) =>
              column.id && (
                <div key={column.id} className={styles.item}>
                  <Checkbox
                    id={`column-toggle-${column.id}`}
                    className={styles.checkbox}
                    checked={column.isVisible}
                    onChange={() => handleToggleColumn(column.id)}
                  />
                  <label htmlFor={`column-toggle-${column.id}`}>
                    {column.label}
                  </label>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
});

export default RemainsTableSettings;
